import JSEncrypt from 'jsencrypt';

// Реплейсить переноса строк нужно для локального публичного ключа в переменных окружения.
const publicKeyPem = process.env.REACT_APP_DIRECT_PUBLIC_KEY_PEM?.replace(/\\n/g, '\n');

/**
 * Шифрует строку RSA-публичным ключом (PEM) с помощью JSEncrypt.
 * @param {string} plainText - Строка для шифрования.
 * @param {string} publicKeyPem - Публичный ключ в PEM-формате.
 * @returns {string | false} - base64-строка зашифрованных данных или false при неуспехе.
 */
export function encryptWithRSAPublicKey(plainText: string): string | false {
    if (!publicKeyPem) {
        return false;
    }

    const encryptor = new JSEncrypt();
    encryptor.setPublicKey(publicKeyPem);

    return encryptor.encrypt(plainText);
}
